import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../../PermissionSetTypes'
import { PermissionType } from '../../PermissionType'
import { DefaultSuperAdminPermissionSet, defaultSuperAdminPermissionSetGrouping } from './DefaultSuperAdminPermissions'
import { SuperAdminOrganizationPermissions } from './SuperAdminPermissions'

export enum SiteReliabilityEngineerPermissionSet {
  SiteReliabilityEngineer = 'super_admin_site_reliability_engineer',
}

export const siteReliabilityEngineerPermissionSetGrouping: IPermissionSetGrouping<SiteReliabilityEngineerPermissionSet> =
  {
    key: PermissionSetGroupingKey.SuperAdminSiteReliabilityEngineer,
    active: {
      [SiteReliabilityEngineerPermissionSet.SiteReliabilityEngineer]: [
        ...defaultSuperAdminPermissionSetGrouping.active[DefaultSuperAdminPermissionSet.DefaultSuperAdmin],
        ...SuperAdminOrganizationPermissions.manageAny,
        PermissionType.ENABLE_RESTRICTED_FEATURE_FLAGS,
      ],
    },
    unAssignablePermissionSets: [SiteReliabilityEngineerPermissionSet.SiteReliabilityEngineer],
    isSuperAdminSet: true,
  }
